import Password from "./container";

export default Password;
